import { useContext, type Context } from 'react';

export const useExistingContext: <T>(contextType: Context<T>) => T = contextType => {
  const context = useContext(contextType);
  if (context === undefined) {
    throw new Error(`trying to use context ${contextType.displayName} without a proper provider!`);
  }
  return context;
};
